import { Link } from "react-router-dom";
import Paragraph from "components/Typography/Paragraph"
import Button from "components/Button"
import Heading from "components/Typography/Header"
import Logo from "components/Logo"
import { Mail, HelpCircle } from 'lucide-react'

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className='py-24 relative overflow-hidden'>
            <div className='absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5'></div>
            
            <div className='max-w-7xl mx-auto px-6 relative z-10'>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
                    <div className="lg:col-span-1 space-y-6">
                        <Logo href="/" />
                        <Paragraph className=" leading-relaxed">
                            SkyPay; hızlı, kolay ve güvenilir dijital ödeme çözümü olarak hizmet verir. Güvenli altyapımızla oyun kredilerinizi anında alın.
                        </Paragraph>
                        <div className="flex gap-4">
                            <div className="w-10 h-10 bg-gradient-to-r from-primary to-secondary rounded-xl flex items-center justify-center hover:shadow-lg hover:shadow-primary/25 transition-all duration-300 cursor-pointer">
                                <Mail size={20} className="text-white" />
                            </div>
                        </div>
                    </div>

                    <div className="space-y-6">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 bg-gradient-to-r from-secondary to-primary rounded-lg flex items-center justify-center">
                                <HelpCircle size={16} className="text-white" />
                            </div>
                            <Heading level={4} className="text-xl font-semibold text-white-100">Destek</Heading>
                        </div>
                        <div className="space-y-3">
                            <Link to="/iletisim" className="block group">
                                <Paragraph className=" hover:text-primary transition-colors duration-300 group-hover:translate-x-1">
                                    İletişim
                                </Paragraph>
                            </Link>
                            <div className="group">
                                <Paragraph className="">
                                    E-posta: <span className="text-primary font-semibold">info@SkyPay.com.tr</span>
                                </Paragraph>
                            </div>
                        </div>
                    </div>

                    <div className="space-y-6">
                        <div className="flex items-center gap-3">
                            <div className="w-8 h-8 bg-gradient-to-r from-primary to-secondary rounded-lg flex items-center justify-center">
                                <Mail size={16} className="text-white" />
                            </div>
                            <Heading level={4} className="text-white-100 text-xl font-semibold">Güncellemeler</Heading>
                        </div>
                        <Paragraph className="">
                            SkyPay ile en son güncellemeler ve özel tekliflerden haberdar olun.
                        </Paragraph>
                        <div className="space-y-4">
                            <input 
                                className="w-full p-4 rounded-xl border border-gray-300  placeholder-gray-500 focus:border-primary/50 focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all duration-300" 
                                type="email" 
                                placeholder="E-posta adresinizi yazın"
                                style={{backgroundColor: '#ffffff'}}
                            />
                            <Button className="w-full bg-gradient-to-r from-primary to-secondary hover:from-primary/90 hover:to-secondary/90 text-white font-semibold py-3 rounded-xl shadow-lg hover:shadow-primary/25 transition-all duration-300 hover:scale-105">
                                Abone Ol
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-gray-200">
                    <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                        <Paragraph className="">
                            Tüm Hakları Saklıdır. <span className="text-primary font-semibold">© {currentYear} SkyPay</span>
                        </Paragraph>
                        <div className="flex items-center gap-2">
                            <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
                            <Paragraph className=" text-sm">
                                Güvenli ve Hızlı Hizmet
                            </Paragraph>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer